import React from "react";
import { useCurrency } from "../../hooks/useCurrency";

const CurrencyDisplay = ({
  usdAmount,
  className = "font-body",
  showCurrency = true,
  precision = 2,
  loading: externalLoading = false,
}) => {
  const { convertUSDToDisplay, formatAmount, effectiveCurrency, isLoaded } =
    useCurrency();

  if (!isLoaded || externalLoading) {
    return (
      <span
        className={`inline-block bg-gray-200 animate-pulse rounded ${className}`}
      >
        Loading...
      </span>
    );
  }

  if (usdAmount === null || usdAmount === undefined) {
    return <span className={className}>--</span>;
  }

  const displayAmount = convertUSDToDisplay(usdAmount);

  if (showCurrency) {
    const formattedAmount = formatAmount(displayAmount, effectiveCurrency);
    return <span className={className}>{formattedAmount}</span>;
  }

  return <span className={className}>{displayAmount.toFixed(precision)}</span>;
};

export default CurrencyDisplay;
